// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "" + ({"182": "gsap-vendor","460": "quickjs-sandbox","498": "geo-vendor",}[chunkId] || chunkId) + "." + {"182": "a93f00ce13c6f9fa","191": "9f3f6c0a60664851","396": "196735983bfee432","460": "e34a1dadb083b7e5","498": "144f3a3024e1dab0","917": "1aadd22cca5e2de4","985": "1b79ccbd7fd146c4",}[chunkId] + ".chunk.js"
}